// extracted by mini-css-extract-plugin
module.exports = {"component":"_3MUpa","overlay":"zEUXe","list":"pPX04","heading":"_3vomR","header":"_3Aewi","subHeader":"ttlSB","optionButton":"_2C59D","submit":"_3qers"};